(function () {
  angular
    .module('kareo.ui.shared.modules.api.product.k-product-service', [])
    .factory('kProductService', kProductService);

  kProductService.$inject = ['$http'];
  function kProductService($http) {
    const svc = {};

    svc.getProductFeaturesForCustomer = getProductFeaturesForCustomer;

    return svc;

    // ----------------------------------------------------------------------

    function getProductFeaturesForCustomer() {
      return $http
        .get('/common-ui/api/customer/productFeatures', {
          cache: true
        })
        .then((response) => {
          return response.data;
        });
    }
  }
})();
